export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            APP下载
          </h2>
          <p className="mt-3 text-sm text-foreground-500">随时随地，畅享高清影视</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 rounded-2xl p-8 md:p-12">
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-heading font-semibold text-xl md:text-2xl text-foreground-900 mb-4">
                7777影院 APP — 把影院装进口袋
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                下载7777影院APP，支持离线缓存、夜间模式、倍速播放等实用功能。
                无论在地铁、旅行还是睡前，打开APP就能享受流畅的观影体验。
                新用户注册即享会员专属片库和无广告观影特权。
              </p>
              <div className="flex flex-wrap gap-3 justify-center md:justify-start">
                <button className="px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                  App Store
                </button>
                <button className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-android-fill mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                  安卓下载
                </button>
              </div>
              <p className="mt-4 text-xs text-foreground-400">支持 iOS 14+ 和 Android 8.0+，安装包体积仅 35MB</p>
            </div>
            <div className="shrink-0">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%2C%20warm%20dark%20theme%20with%20golden%20accents%2C%20clean%20minimal%20UI%20design%2C%20cinematic%20app%20screenshot%20mockup%2C%20elegant%20typography%2C%20no%20real%20text%20visible%2C%20professional%20product%20photography&width=600&height=600&seq=app-screen-2026&orientation=squarish"
                  alt="7777影院APP界面展示"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}